<template>
    <span>
        <a href="javascript:void(0)" v-if="showSection" @click="toggleSection">
            <img src="../assets/img/eye-svgrepo-com.svg" :width="iconWidth"/>
        </a>
        <a href="javascript:void(0)" v-if="!showSection" @click="toggleSection"> 
            <img src="../assets/img/eye-closed-svgrepo-com.svg" :width="iconWidth"/>
        </a>  
    </span>
</template>

<script>
export default {
    name: 'ShowHideEye',
    props: {
        showSection: Boolean,
        iconWidth: {
            type: String,
            default : '4%'
        }
    },
    methods: {
        toggleSection() {
            this.$emit('toggle', !this.showSection);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>